import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/templates/Home';
import LoginPage from '../components/templates/Login';
import RegisterPage from '../components/templates/Register';
import RequestPasswordReset from '../components/templates/RequestPasswordReset';
import PasswordReset from '../components/templates/PasswordReset';
import NotFound from '../components/templates/NotFound';
// plan components
import PlanList from '../components/organisms/Home/Plan/PlanList';
import PlanForm from '../components/organisms/Home/Plan/PlanForm';
import DemographyForm from '../components/organisms/Home/Plan/DemographyForm';
import RenewableEnergyForm from '../components/organisms/Home/Plan/RenewableEnergyForm';
import PhysicalInfoForm from '../components/organisms/Home/Plan/PhysicalInfoForm';
import LandCoverForm from '../components/organisms/Home/Plan/LandCoverForm';
import RoadAccessForm from '../components/organisms/Home/Plan/RoadAccessForm';
import Stakeholders from '../components/organisms/Home/PlanningProcess/Stakeholders';
import EnergySubCommitee from '../components/organisms/Home/PlanningProcess/EnergySubCommitee';
import EnergyBaseline from '../components/organisms/Home/PlanningProcess/EnergyBaseline';
import EnergyBaselineBAT from '../components/organisms/Home/PlanningProcess/EnergyBaselineBAT';
import EnergyBaselineMHP from '../components/organisms/Home/PlanningProcess/EnergyBaseLineMHP';
import VisionMission from '../components/organisms/Home/PlanningProcess/VisionMission';
import OppAndChallenges from '../components/organisms/Home/PlanningProcess/OppAndChallenges';
import Activities from '../components/organisms/Home/PlanningProcess/Activities';
import PriorityAssessment from '../components/organisms/Home/PlanningProcess/PriorityAssessment';
import Fundings from '../components/organisms/Home/PlanningProcess/Fundings';
import Rankings from '../components/organisms/Home/PlanningProcess/Rankings';
import SelectedActivities from '../components/organisms/Home/PlanningProcess/SelectedActivities';
import FinalPage from '../components/organisms/Home/PlanningProcess/FinalPage';
// admin components
import Admin from '../components/templates/Admin';
import AdminMap from '../components/organisms/Admin/Dashboard/Map';
import CreateUser from '../components/organisms/Admin/Users/CreateUser';
import EditUser from '../components/organisms/Admin/Users/EditUser';
import UserList from '../components/organisms/Admin/Users/UserList';
import SHS_AC_List from '../components/organisms/Admin/EnergyCosts/SHS_AC_List';
import SHS_DC_List from '../components/organisms/Admin/EnergyCosts/SHS_DC_List';
import MHPList from '../components/organisms/Admin/EnergyCosts/MHPList';
import GridList from '../components/organisms/Admin/EnergyCosts/GridList';
import SMGList from '../components/organisms/Admin/EnergyCosts/SMGList';
import AdminPlanList from '../components/organisms/Admin/Plans';
import store from '../store'; 

// landing page
import LandingPg from '../components/templates/LandingPg';
// import { offset } from 'highcharts';

Vue.use(VueRouter)
const routes = [
    {
        path:'/',
        name:'landing-page',
        component: LandingPg
    },{
        path: '/home',
        component: Home,
        children: [
            {path: '', component: PlanList, name: 'home'},
            {path: 'plan', component: PlanForm, name: 'create-plan'},
            {path: 'plan/:id(\\d+)', component: PlanForm, name: 'edit-plan'},
            {path: 'plan/:id(\\d+)/demography', component: DemographyForm, name: 'edit-demography-info'},
            {path: 'plan/:id(\\d+)/renewable-energy', component: RenewableEnergyForm, name: 'edit-renewable-energy-info'},
            {path: 'plan/:id(\\d+)/physical', component: PhysicalInfoForm, name: 'edit-physical-info'},
            {path: 'plan/:id(\\d+)/land-cover', component: LandCoverForm, name: 'edit-land-cover-info'},
            {path: 'plan/:id(\\d+)/road-access', component: RoadAccessForm, name: 'edit-road-access-info'},
            // planning process
            {path: 'plan/:id(\\d+)/stakeholders', component: Stakeholders, name: 'stakeholders'},
            {path: 'plan/:id(\\d+)/sub-commitee', component: EnergySubCommitee, name: 'energy-sub-commitee'},
            {path: 'plan/:id(\\d+)/energy-baseline', component: EnergyBaseline, name: 'energy-baseline'},
            {path: 'plan/:id(\\d+)/energy-baseline-bat', component: EnergyBaselineBAT, name: 'energy-baseline-bat'},
            {path: 'plan/:id(\\d+)/energy-baseline-mhp', component: EnergyBaselineMHP, name: 'energy-baseline-mhp'},
            {path: 'plan/:id(\\d+)/vision-mission', component: VisionMission, name: 'vision-mission'},
            {path: 'plan/:id(\\d+)/opp-and-challenges', component: OppAndChallenges, name: 'opp-and-challenges'},
            {path: 'plan/:id(\\d+)/activities', component: Activities, name: 'activities'},
            {path: 'plan/:id(\\d+)/pa', component: PriorityAssessment, name: 'priority-assessment'},
            {path: 'plan/:id(\\d+)/fundings', component: Fundings, name: 'fundings'},
            {path: 'plan/:id(\\d+)/rankings', component: Rankings, name: 'rankings'},
            {path: 'plan/:id(\\d+)/sa', component: SelectedActivities, name: 'sa'},
            {path: 'plan/:id(\\d+)/final', component: FinalPage, name: 'final-page'},
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterPage
    },
    {
        path: '/request-password-reset',
        name: 'request-password-reset',
        component: RequestPasswordReset
    },
    {
        path: '/password-reset/:token',
        name: 'password-reset',
        component: PasswordReset
    },
    {
        path: '/cl-admin/',
        name: 'admin',
        component: Admin,
        redirect: '/cl-admin/map',
        children: [
           {path: 'map', component: AdminMap, name: 'admin-map'},
           {path: 'users', component: UserList, name: 'user-list'},
           {path: 'add-user', component: CreateUser, name: 'add-user'},
           {path: 'users/:user_id(\\d+)', component: EditUser, name: 'edit-user'},
           {path: 'plans', component: AdminPlanList, name: 'admin-plan-list'},
           {path: 'shs-ac-costs', component: SHS_AC_List, name: 'shs-ac-costs'},
           {path: 'shs-dc-costs', component: SHS_DC_List, name: 'shs-dc-costs'},
           {path: 'mhp-costs', component: MHPList, name: 'mhp-costs' },
           {path: 'grid-costs', component: GridList, name: 'grid-costs' },
           {path: 'smg-costs', component: SMGList, name: 'smg-costs' },
        ]
    },
    
    // {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
    {
        path: '/notfound',
        name: 'notfound',
        component: NotFound
    },
    {
        path: '*',
        name: 'page404', component: NotFound
    },
    
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
    if (/^\/home\/plan\/(d+)*/.test(to.path) && store.getters['isDashboardMode'])
    {
        store.dispatch('toggleMode');
    }
    if (to.name==='home')
    {
        store.dispatch('plan/clearPlan');
    }
    if (['home', 'admin'].includes(to.name) && !store.getters['users/isAuthenticated'])
    {
        next({ name: 'landing-page' });
    }
    else if (['admin'].includes(to.name) && !store.getters['users/isManagerOrHigher'])
    {
        next({ name: 'home' });
    }
    else if ( (to.name==='login' || to.fullPath=='/ ') && store.getters['users/isAuthenticated'])
    {
        store.getters['users/isManagerOrHigher'] ? next({name: 'admin'}) : next({name: 'home'});
    }
    else
    {
      next();
    }
});

router.afterEach(() =>
{
    if (store.getters['reloadRequired'])
    {
        store.dispatch('setReloadRequired', false);
        location.reload();
    }
});

export default router
